import { useState } from "react"
import { Box, Popover, Stack, Typography } from "@mui/material"
import { navigate } from "lib/routes/navigate"
import { Repeat } from "lib/@components/repeat"
import Iconify from "minimals-template/components/Iconify"
import { RateCardMenuItem } from "./rate-card-menu-item"

export function RateCardCell({ name, id, count, variants }) {
    const [anchor, setAnchor] = useState(null)

    if (!name && (!count || count === 0)) {
        return (
            <Typography variant="body2" color="text.secondary">
                {"—"}
            </Typography>
        )
    }

    const total = count ?? 1
    const cards = collectCards()

    return (
        <>
            <Box
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 1,
                    pl: 0.5,
                    py: 0.75,
                    borderRadius: 1,
                    cursor: "pointer",
                    "&:hover": { bgcolor: "action.hover" },
                }}
                onClick={handleClick}
            >
                <Iconify
                    icon="solar:user-id-broken"
                    width={20}
                    height={20}
                    sx={{ color: "common.black", flexShrink: 0 }}
                />
                <Typography variant="body2" sx={{ fontSize: 16, fontWeight: 500 }}>
                    {total}
                </Typography>
                <Iconify icon="ic:round-arrow-drop-down" width={24} sx={{ color: "text.primary" }} />
            </Box>
            <Popover
                open={Boolean(anchor)}
                anchorEl={anchor}
                onClose={closePopover}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                slotProps={{ paper: { sx: { p: 1, minWidth: 200 } } }}
            >
                <Stack spacing={0}>
                    <Repeat list={cards} item={<RateCardMenuItem onNavigate={navigateToCard} />} keyFn={getCardKey} />
                </Stack>
            </Popover>
        </>
    )

    function collectCards() {
        const seen = new Map()
        if (id && name) seen.set(id, { id, name })
        for (const v of variants || []) {
            if (v.rateCardId && !seen.has(v.rateCardId)) {
                seen.set(v.rateCardId, { id: v.rateCardId, name: v.rateCardName || v.rateCardId })
            }
        }
        return Array.from(seen.values())
    }

    function handleClick(e) {
        e.stopPropagation()
        setAnchor(e.currentTarget)
    }

    function closePopover(e) {
        if (e?.stopPropagation) e.stopPropagation()
        setAnchor(null)
    }

    function navigateToCard(cardId, e) {
        e.stopPropagation()
        closePopover()
        navigate(`/app/optimiser/rate-cards/${cardId}`)
    }
}

function getCardKey(card) {
    return card.id
}
